import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "search__header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__delimiter" }, null, -1)
const _hoisted_3 = { class: "search__dots" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__expand" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { style: {"display":"none"} }, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 2,
  class: "search__empty"
}
const _hoisted_10 = { class: "heading-xl" }
const _hoisted_11 = { class: "search__left-bar" }
const _hoisted_12 = { class: "search__heading heading-xl" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { id: "searchLeftSidebar" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchFromSelect = _resolveComponent("SearchFromSelect")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NButtonGroup = _resolveComponent("NButtonGroup")!
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_NLoadingDots = _resolveComponent("NLoadingDots")!
  const _component_DisplayTypesButtonGroup = _resolveComponent("DisplayTypesButtonGroup")!
  const _component_NAlertBadge = _resolveComponent("NAlertBadge")!
  const _component_NThemeImage = _resolveComponent("NThemeImage")!
  const _component_Confidence = _resolveComponent("Confidence")!
  const _component_CardItemProxy = _resolveComponent("CardItemProxy")!
  const _component_ClusterItem = _resolveComponent("ClusterItem")!
  const _component_EventResultPage = _resolveComponent("EventResultPage")!
  const _component_CaseClusterItem = _resolveComponent("CaseClusterItem")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_SearchSidebar = _resolveComponent("SearchSidebar")!
  const _component_SearchOverlay = _resolveComponent("SearchOverlay")!
  const _component_ListPage = _resolveComponent("ListPage")!
  const _component_DetectionDialog = _resolveComponent("DetectionDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ListPage, {
      state: _ctx.state,
      statistics: false,
      "first-get": false,
      "has-left-bar": "",
      "has-main-header": "",
      class: _normalizeClass(_ctx.pageClasses)
    }, {
      mainheader: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (!_ctx.state.showOverlay)
            ? (_openBlock(), _createBlock(_component_SearchFromSelect, {
                key: 0,
                "source-module": _ctx.sourceModule
              }, null, 8, ["source-module"]))
            : _createCommentVNode("", true),
          _createVNode(_component_NButton, {
            type: "secondary",
            icon: "upload",
            onClick: _ctx.backToStart
          }, null, 8, ["onClick"])
        ])
      ]),
      filters: _withCtx(() => [
        _createVNode(_component_FilterSection, {
          filter: _ctx.module.filter,
          "scheme-small": _ctx.smallFilterLayout,
          "scheme-large": _ctx.bigFilterLayoutByPageType,
          "has-report": _ctx.canCreateReport,
          "has-pinned-fields": ""
        }, {
          small: _withCtx(() => [
            (_ctx.resultsModule.searchPageTypes.length > 1)
              ? (_openBlock(), _createBlock(_component_NButtonGroup, {
                  key: 0,
                  items: _ctx.resultsModule.searchPageTypes,
                  modelValue: _ctx.state.pageType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.pageType) = $event)),
                  disabled: _ctx.sourceModule.hasError && !_ctx.sourceModule.loading
                }, null, 8, ["items", "modelValue", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["filter", "scheme-small", "scheme-large", "has-report"])
      ]),
      statistic: _withCtx(() => [
        (!_ctx.showEmpty && !_ctx.isEventsPage)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"]),
              _hoisted_2
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.state.displayType !== 'map')
          ? (_openBlock(), _createBlock(_component_SortDropdown, {
              key: 1,
              items: _ctx.sortTypes,
              modelValue: _ctx.module.filter.current.ordering,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
            }, null, 8, ["items", "modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.resultsModule.module.loading)
            ? (_openBlock(), _createBlock(_component_NLoadingDots, {
                key: 0,
                type: "inverted"
              }))
            : _createCommentVNode("", true)
        ]),
        _hoisted_4,
        (_ctx.hasRowView)
          ? (_openBlock(), _createBlock(_component_DisplayTypesButtonGroup, {
              key: 2,
              modelValue: _ctx.state.displayType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.displayType) = $event)),
              availableItems: _ctx.availableDisplayTypes
            }, null, 8, ["modelValue", "availableItems"]))
          : _createCommentVNode("", true)
      ]),
      "items-empty": _withCtx(() => [
        _hoisted_5
      ]),
      items: _withCtx(() => [
        (_ctx.debugMode)
          ? (_openBlock(), _createElementBlock("pre", _hoisted_6, [
              _createTextVNode("        " + _toDisplayString(_ctx.state) + " ", 1),
              _hoisted_7,
              _createTextVNode("\n        " + _toDisplayString(_ctx.resultsModule.looksLike) + "\n        Debug Filter: ", 1),
              _hoisted_8,
              _createTextVNode("\n        " + _toDisplayString(_ctx.module.filter.current) + "\n      ", 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showMultiselectWarning)
          ? (_openBlock(), _createBlock(_component_NAlertBadge, {
              key: 1,
              type: "negative",
              class: "search__multiselect_warning"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('search.date_multiselect_warning', 'f')), 1)
              ]),
              _: 1
            }))
          : (_ctx.showEmpty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_NThemeImage, { "css-var": "--image-empty-search-results" }),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('search.input_error')), 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", {
                  class: _normalizeClass(['search__result-items', { 'search__result-items_row': _ctx.state.displayType === 'full' && _ctx.hasRowView }])
                }, [
                  (_ctx.isCardsPage)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.module.items, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "search__item-wrapper",
                          key: item.id
                        }, [
                          _createVNode(_component_Confidence, {
                            class: _normalizeClass(_ctx.confidenceClass),
                            value: item.looks_like_confidence,
                            objects: _ctx.state.objectType,
                            align: "left",
                            type: "number"
                          }, null, 8, ["class", "value", "objects"]),
                          (_openBlock(), _createBlock(_component_CardItemProxy, {
                            "data-id": item.id,
                            key: item.id,
                            display: true,
                            type: _ctx.state.cardType,
                            item: item,
                            "model-acl": _ctx.resultsModule.modelAcl,
                            displayType: _ctx.state.displayType,
                            selected: !!_ctx.sidebarModule.getItem(_ctx.cardsSidebarType, item.id),
                            opened: _ctx.getIsItemOpened(item),
                            onSelect: () => _ctx.sidebarModule.addItemAndOpen(_ctx.cardsSidebarType, item),
                            onAction: (v) => _ctx.actionHandler(item.id, v)
                          }, null, 8, ["data-id", "type", "item", "model-acl", "displayType", "selected", "opened", "onSelect", "onAction"]))
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (_ctx.isClustersPage)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.module.items, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "search__item-wrapper",
                          key: item.id
                        }, [
                          _createVNode(_component_Confidence, {
                            class: _normalizeClass(_ctx.confidenceClass),
                            value: item.looks_like_confidence,
                            objects: _ctx.state.objectType,
                            align: "left",
                            type: "number"
                          }, null, 8, ["class", "value", "objects"]),
                          _createVNode(_component_ClusterItem, {
                            objects: _ctx.state.objectType,
                            item: item,
                            type: _ctx.state.pageType,
                            "cluster-selected": !!_ctx.sidebarModule.getItem(_ctx.pageSidebarType, item.id),
                            "card-selected": !!_ctx.sidebarModule.getItem(_ctx.cardsSidebarType, item.card),
                            "opened-item": _ctx.getOpenedTypeByCluster(item),
                            onAction: ($event: any) => (_ctx.openSearchTypeInTab(item)),
                            onSelectCard: _ctx.navigateToCard
                          }, null, 8, ["objects", "item", "type", "cluster-selected", "card-selected", "opened-item", "onAction", "onSelectCard"])
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (_ctx.isEventsPage)
                    ? (_openBlock(), _createBlock(_component_EventResultPage, {
                        key: 2,
                        module: _ctx.module,
                        state: _ctx.state,
                        onAction: _cache[3] || (_cache[3] = (v, item) => _ctx.actionHandler(item.id, v, { ...item })),
                        "page-sidebar-type": _ctx.pageSidebarType,
                        "cards-sidebar-type": _ctx.cardsSidebarType,
                        "confidence-class": _ctx.confidenceClass,
                        "default-event-action": _ctx.defaultEventAction
                      }, null, 8, ["module", "state", "page-sidebar-type", "cards-sidebar-type", "confidence-class", "default-event-action"]))
                    : _createCommentVNode("", true),
                  (_ctx.isCaseClustersPage)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.module.items, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "search__item-wrapper",
                          key: item.id
                        }, [
                          (_openBlock(), _createBlock(_component_CaseClusterItem, {
                            "show-name": true,
                            "show-role": true,
                            "show-card": true,
                            "show-case": true,
                            "show-events-count": true,
                            key: item.id,
                            item: item,
                            "cluster-selected": _ctx.getIsItemOpened(item),
                            onAction: (v) => _ctx.actionHandler(item.id, v),
                            onClick: ($event: any) => (_ctx.openSearchTypeInTab(item)),
                            onCardClick: _cache[4] || (_cache[4] = (card) => _ctx.sidebarModule.addItemAndOpen(_ctx.cardsSidebarType, card)),
                            class: "search__participant-item",
                            showFullframe: true,
                            objects: "faces"
                          }, {
                            thumbnailConfidence: _withCtx(() => [
                              _createVNode(_component_Confidence, {
                                class: _normalizeClass(_ctx.confidenceClass),
                                value: item.looks_like_confidence,
                                objects: _ctx.state.objectType,
                                align: "left",
                                type: "number"
                              }, null, 8, ["class", "value", "objects"])
                            ]),
                            _: 2
                          }, 1032, ["item", "cluster-selected", "onAction", "onClick"]))
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ], 2),
                _createVNode(_component_InfiniteScroll, {
                  onLoadMore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.module.append())),
                  filters: _ctx.module.filter.current
                }, null, 8, ["filters"])
              ], 64))
      ]),
      "left-bar": _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('search.search', 'f')), 1),
          (!_ctx.sourceModule.hasError && _ctx.sourceModule.loaded)
            ? (_openBlock(), _createBlock(_component_SearchSidebar, {
                key: 0,
                "source-module": _ctx.sourceModule,
                onShowDetectDialog: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDetectionDialogVisible = true))
              }, null, 8, ["source-module"]))
            : _createCommentVNode("", true),
          (_ctx.module.items.length && _ctx.state.displayType === 'map')
            ? (_openBlock(), _createBlock(_component_SortDropdown, {
                key: 1,
                items: _ctx.sortTypes,
                modelValue: _ctx.module.filter.current.ordering,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
              }, null, 8, ["items", "modelValue"]))
            : _createCommentVNode("", true),
          _hoisted_13
        ])
      ]),
      overlay: _withCtx(() => [
        _createVNode(_component_SearchOverlay, { "source-module": _ctx.sourceModule }, null, 8, ["source-module"])
      ]),
      _: 1
    }, 8, ["state", "class"]),
    (_ctx.isDetectionDialogVisible)
      ? (_openBlock(), _createBlock(_component_DetectionDialog, {
          key: 0,
          "image-file": _ctx.attachment?.file,
          "thumbnail-scale": 1.8,
          customButtonLabel: "search.search",
          onApply: _ctx.selectBBOX,
          onClose: _ctx.closeDetectionDialog
        }, null, 8, ["image-file", "thumbnail-scale", "onApply", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}